import React from 'react';
import { Sizes } from 'styled-components';
import { ProviderField } from '../../models/provider';
import { StyledImage } from './TemplateIcon.styles';

type Props = {
  field: ProviderField;
  height: Sizes;
};

export const TemplateIcon: React.FC<Props> = ({ field, height }) => {
  const { value } = field;

  if (!value) return null;

  return <StyledImage height={height} src={value} alt="" />;
};
